export default {
  GET_REWARD: '@API_GET_REWARD',
  REDEEM_REWARD: '@API_REDEEM_REWARD',
}
